// API Configuration
export const API_BASE_URL = 'https://api-yogi.khushifarm.in/backend';

// API Endpoints
export const API_ENDPOINTS = {
  // Product endpoints
  GET_PRODUCT: `${API_BASE_URL}/get_product.php`,
  ADD_PRODUCT: `${API_BASE_URL}/add_product.php`,
  UPDATE_PRODUCT: `${API_BASE_URL}/update_product.php`,
  DELETE_PRODUCT: `${API_BASE_URL}/delete_product.php`,
  GET_PRODUCT_SALES: `${API_BASE_URL}/get_product_sales.php`,
  GET_PRODUCT_STOCK: `${API_BASE_URL}/get_product_stock.php`,

  // Invoice endpoints
  GET_INVOICE: `${API_BASE_URL}/get_invoice.php`,
  ADD_INVOICE: `${API_BASE_URL}/add_invoice.php`,
  UPDATE_INVOICE: `${API_BASE_URL}/update_invoice.php`,
  DELETE_INVOICE: `${API_BASE_URL}/delete_invoice.php`,
  GET_LAST_INVOICE_NUMBER: `${API_BASE_URL}/get_last_invoice_number.php`,
  GET_REMAINING_AMOUNT: `${API_BASE_URL}/get_remaining_amount.php`,

  // Customer endpoints
  GET_CUSTOMER: `${API_BASE_URL}/get_customer.php`,
  ADD_CUSTOMER: `${API_BASE_URL}/add_customer.php`,
  UPDATE_CUSTOMER: `${API_BASE_URL}/update_customer.php`,
  DELETE_CUSTOMER: `${API_BASE_URL}/delete_customer.php`,

  // Supplier endpoints
  GET_SUPPLIER: `${API_BASE_URL}/get_supplier.php`,
  ADD_SUPPLIER: `${API_BASE_URL}/add_supplier.php`,
  UPDATE_SUPPLIER: `${API_BASE_URL}/update_supplier.php`,
  DELETE_SUPPLIER: `${API_BASE_URL}/delete_supplier.php`,

  // Purchase endpoints
  ADD_PURCHASE_INVOICE: `${API_BASE_URL}/add_purchase_invoice.php`,
  UPDATE_PURCHASE_INVOICE: `${API_BASE_URL}/update_purchase_invoice.php`,
  DELETE_PURCHASE_INVOICE: `${API_BASE_URL}/delete_purchase_invoice.php`,
  UPDATE_PURCHASE_STOCK: `${API_BASE_URL}/update_purchase_stock.php`,

  // Payment endpoints
  GET_PAYMENTS: `${API_BASE_URL}/get_payments.php`,
  CREATE_PAYMENT: `${API_BASE_URL}/create_payment.php`,
  UPDATE_PAYMENT: `${API_BASE_URL}/update_payment.php`,
  DELETE_PAYMENT: `${API_BASE_URL}/delete_payment.php`,

  // Auth endpoints
  LOGIN: `${API_BASE_URL}/login.php`,
};
